import React from 'react';

import './Devices.device.scss';
import BatteryIcon from '../visuals/Battery';
import ItemMenu from '../forms/menu/MenuComponent';
import moment from 'moment';
import {useTranslation} from "react-i18next";
import {PAGES} from "../services/interactions/audit.trail";

function DevicesBaseDevice({ currentUser, device, onAssign, patientList, loading, onUnAssignDevice}) {
    const {t} = useTranslation(['devices']);

    const renderStatus = () => {
        if (!device.patientId) {
            return (<div className="__deviceStatus available"><span>Available</span></div>)
        }
        if (!!device.patientId && !device.dateUpdated) {
            return (<div className="__deviceStatus assigned"><span>Assigned</span></div>)
        }
        if (!!device.patientId && !!device.dateUpdated) {
            if ((Date.now() - device.dateUpdated) < (1000 * 60 * 60 * 0.5)) {
                return (<div className="__deviceStatus inUse"><span>In use</span></div>)
            }
            if ((Date.now() - device.dateUpdated) < (1000 * 60 * 60 * 2)) {
                return (<div className="__deviceStatus inUsePartial"><span>In use</span></div>)
            }
            if ((Date.now() - device.dateUpdated) < (1000 * 60 * 60 * 24) || (Date.now() - device.dateUpdated) >= (1000 * 60 * 60 * 24)) {
                return (<div className="__deviceStatus notTransmitting"><span>No data</span></div>)
            }
        }
    }

    const openAssignDeviceModal = () => {
        if (!!onAssign) {
            onAssign(device);
        }
    }

    const _onUnAssignDevice = () => {
        if (hasPermissionUnAssign()) {
            onUnAssignDevice(device);
        }
    }

    const hasPermissionUnAssign = () => {
        return currentUser.clinician.role === "admin";
    }

    const patientAssigned = patientList.find(p => p._id === device.patientId);
    const patientBio = !!patientAssigned && !!patientAssigned.user ? `${patientAssigned.user.bio.lastname}, ${patientAssigned.user.bio.firstname}` : null;
    const batteryLevel = device.batteryVoltage * 100 > 100 ? 100 : (device.batteryVoltage * 100);

    return (
        <div className="__devicesDevice">
            <p>
                {device.kitId || '--'}
            </p>
            <p>
                {device.deviceId}
            </p>
            <p>
                {
                device.assignedAt ? moment(device.assignedAt).format('DD MMM YY H:mm') : '--'
                }
            </p>
            <p>
                {loading ? 'Loading' : (patientBio ? patientBio : '--')}
            </p>
            {renderStatus()}
            <BatteryIcon hidden={(batteryLevel) > 85} percent={(batteryLevel) * 100} width={20} labeled={false} />
            {
                currentUser.userRoles.devicesAssign.edit?
                    <ItemMenu label={'Device Options'} event={PAGES.USERS_LIST}>
                        <>
                            {!!device.patientId ?
                                <div className={`_option ${!hasPermissionUnAssign() ? '_disabled' : ''}`} onClick={_onUnAssignDevice}>
                                    <p>{t('unassign-device-participant')}</p>
                                </div>
                                :
                                <div className="_option" onClick={openAssignDeviceModal}>
                                    <p>{t('assign-device-participant')}</p>
                                </div>
                            }
                        </>
                    </ItemMenu> : ''
            }
        </div>
    )
}

export default DevicesBaseDevice;
